export const baseURL = process.env.REACT_APP_BASEURL;
export const publicKey = process.env.REACT_APP_PUBLICKEY;
export const secretKey = process.env.REACT_APP_SECRETKEY;
